import { Component } from 'vue-property-decorator';
import './hand-sorting.component.scss';
import HandSortingModal from '@/tsort/views/sorting/modal/hand-sorting/hand-sorting-modal.component';
import SwipeButton from '@/common/components/swipe-button/swipe-button';
import FooterComponent from '@/tsort/views/sorting/footer/footer.component';
import AppConstants from '@/common/constants/app.constants';
import LoadingComponent from '@/common/components/loading/loading.component';
import BaseSortingComponent from '../../base-sorting/base-sorting.component';
import { SortModalType } from '@/tsort/enum/sort-modal-type.enum';
import ErrorMessageUtils from '@/common/utils/error-message.util';
import ErrorCdMsgConstants from '@/common/constants/error-cd-msg.constants';
import LogMsgConstants from '@/common/constants/log-msg.constant';
import StringUtils from '@/common/utils/string.util';

const REF_MODAL = 'handSortingModal';
const FUNCTIONIDTYPE = 1;
@Component({})
export default class HandSortingComponent extends BaseSortingComponent {
  // ------------------ 抽象メソッド ------------------
  getErrCdInvalidScanCodeFieldName(): string {
    return ErrorCdMsgConstants.FUNC_SCAN_CONFIRM_INVALID_SCAN_CODE_FIELD_NAME_MANUAL_SORT_ERR_CD;
  }
  getErrCdExcessEntry(): string {
    return ErrorCdMsgConstants.FUNC_SCAN_CONFIRM_TASK_EXCESS_ENTRY_MANUAL_SORT_ERR_CD;
  }
  getLogMsgExcessEntry(): string {
    return LogMsgConstants.FUNC_SCAN_CONFIRM_TASK_EXCESS_ENTRY_MANUAL_SORT_LOG_MSG;
  }
  getErrMsgOverMaxInput(maxInput: number): string {
    return ErrorMessageUtils.buildErrorMessage(
      ErrorCdMsgConstants.FUNC_SCAN_CONFIRM_OVER_MAX_INPUT_QUANTITY_MANUAL_SORT_ERR_CD,
      StringUtils.buildMsg([maxInput.toString()], ErrorCdMsgConstants.FUNC_SCAN_CONFIRM_OVER_MAX_INPUT_QUANTITY_ERR_MSG)
    );
  }
  getErrMsgInvalidInputQuantity(): string {
    return ErrorMessageUtils.buildErrorMessage(
      ErrorCdMsgConstants.FUNC_SCAN_CONFIRM_INVALID_INPUT_QUANTITY_MANUAL_SORT_ERR_CD,
      ErrorCdMsgConstants.FUNC_SCAN_CONFIRM_INVALID_INPUT_QUANTITY_MANUAL_SORT_ERR_MSG
    );
  }
  getRefModal(): string {
    return REF_MODAL;
  }
  handleCatchError(): void {
    this.scanFailed();
  }
  getWorkInstruction(): number {
    return FUNCTIONIDTYPE;
  }
  // ----------------------抽象メソッドの終わり----------------------
  /* SCAN MODE
   * REPRESENTATIVE SCAN => true
   * 100% SCAN => false
   */

  public async mounted(): Promise<void> {
    (this.$refs.swipeButton as SwipeButton)?.handleError(false);
    await this.getScanMode();
    this.inputQuantityStore = [];
  }

  render() {
    return (
      <main v-frag>
        {/* Scroll Scan Fields */}
        {this.scrollScanFields}
        {/* Footer Area */}
        <FooterComponent footerOfPage={AppConstants.FOOTER_HAND_SORTING}>
          <template slot="swipeButton">
            <SwipeButton on-finished-swipe={() => this.handleModal(SortModalType.SCAN)} ref="swipeButton" text="OK" />
          </template>
        </FooterComponent>
        {/* Modal */}
        <HandSortingModal
          ref={REF_MODAL}
          inputQuantityStore={this.inputQuantityStore}
          isShow={this.isShow}
          modeType={this.scanMode}
          targetTask={this.targetTaskResponse}
          scanCodePattern={this.scanConfirmField.scanCode}
          fieldNameScanCode={this.fieldNameScanCode}
          on-exitBtn={() => this.exitBtnHandle()}
          on-accept-btn={(scanConfirmPacket: { inputQuantity: string; chuteNo: string; maxInputQuantity: number }) =>
            this.acceptBtnHandle(scanConfirmPacket)
          }
          on-changeTaskList={() => (this.inputQuantityStore = [])}
        ></HandSortingModal>
        <LoadingComponent isActive={this.isLoading} />
      </main>
    );
  }
}
